function recursiveTrim(obj) {
  if (typeof obj === 'string') {
    return obj.trim();
  }
  if (Array.isArray(obj)) {
    return obj.map(recursiveTrim);
  }
  if (obj !== null && typeof obj === 'object') {
    const trimmedObj = {};
    Object.entries(obj).forEach(([key, value]) => {
      trimmedObj[key] = recursiveTrim(value);
    });
    return trimmedObj;
  }
  return obj;
}

export default recursiveTrim;
